module.exports = __webpack_public_path__ + "static/media/bird.bbef232e.mp3";